import { useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import {
  LayoutDashboard, Swords, Shield, Target, Skull, CircleDot, Radio,
  Settings2, History, MonitorPlay, Gamepad2, SlidersHorizontal, Menu, X, ListChecks,
} from "lucide-react";

const NAV = [
  { to: "/", label: "Dashboard", icon: LayoutDashboard, testid: "nav-dashboard" },
  { to: "/attack", label: "Attacco", icon: Swords, testid: "nav-attack" },
  { to: "/defense", label: "Difesa", icon: Shield, testid: "nav-defense" },
  { to: "/objectives", label: "Obiettivi", icon: Target, testid: "nav-objectives" },
  { to: "/penalties", label: "Penitenze", icon: Skull, testid: "nav-penalties" },
  { to: "/custom", label: "Ruote Custom", icon: CircleDot, testid: "nav-custom" },
  { to: "/streaming", label: "Streaming", icon: Radio, testid: "nav-streaming" },
  { to: "/content", label: "Gestione", icon: ListChecks, testid: "nav-content" },
  { to: "/history", label: "Cronologia", icon: History, testid: "nav-history" },
  { to: "/overlay-editor", label: "Overlay OBS", icon: MonitorPlay, testid: "nav-overlay-editor" },
  { to: "/stream-deck", label: "Stream Deck", icon: Gamepad2, testid: "nav-streamdeck" },
  { to: "/settings", label: "Impostazioni", icon: SlidersHorizontal, testid: "nav-settings" },
];

export default function Layout({ children }) {
  const [open, setOpen] = useState(false);
  const loc = useLocation();

  return (
    <div className="min-h-screen flex bg-[#080a0f]">
      {/* Sidebar */}
      <aside
        className={`fixed z-40 lg:static top-0 left-0 h-full w-64 bg-[#0b0e16] border-r border-[#1e293b] flex flex-col transition-transform duration-200 ${
          open ? "translate-x-0" : "-translate-x-full lg:translate-x-0"
        }`}
      >
        <div className="px-5 py-5 border-b border-[#1e293b] flex items-center gap-3">
          <div className="w-9 h-9 rounded bg-amber-500 flex items-center justify-center">
            <CircleDot className="w-5 h-5 text-[#080a0f]" strokeWidth={2.5} />
          </div>
          <div>
            <div className="font-display font-extrabold text-lg tracking-wide text-white leading-none">
              SIEGE WHEEL
            </div>
            <div className="text-[10px] tracking-widest text-amber-500 font-semibold uppercase">
              Stream Control
            </div>
          </div>
        </div>
        <nav className="flex-1 overflow-y-auto py-3">
          {NAV.map((n) => {
            const Icon = n.icon;
            return (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.to === "/"}
                data-testid={n.testid}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-5 py-2.5 text-sm font-semibold transition-colors border-l-[3px] ${
                    isActive
                      ? "bg-[#131722] text-amber-400 border-amber-500"
                      : "text-slate-300 border-transparent hover:bg-[#11141d] hover:text-white"
                  }`
                }
              >
                <Icon className="w-[18px] h-[18px]" />
                {n.label}
              </NavLink>
            );
          })}
        </nav>
        <div className="px-5 py-3 border-t border-[#1e293b] text-[10px] text-slate-500 leading-tight">
          Unofficial fan-made utility. Not affiliated with or endorsed by Ubisoft.
        </div>
      </aside>

      {open && (
        <div className="fixed inset-0 bg-black/60 z-30 lg:hidden" onClick={() => setOpen(false)} />
      )}

      {/* Main */}
      <div className="flex-1 min-w-0 flex flex-col">
        <header className="lg:hidden sticky top-0 z-20 bg-[#0b0e16] border-b border-[#1e293b] px-4 py-3 flex items-center justify-between">
          <button data-testid="mobile-menu-toggle" onClick={() => setOpen(!open)} className="text-white p-1">
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
          <span className="font-display font-bold text-white tracking-wide">SIEGE STREAM WHEEL</span>
          <span className="w-6" />
        </header>
        <main key={loc.pathname} className="flex-1 min-w-0">{children}</main>
      </div>
    </div>
  );
}

export function PageHeader({ title, subtitle, accent = "amber", right }) {
  const colors = {
    amber: "border-amber-500 text-amber-400",
    blue: "border-blue-500 text-blue-400",
    orange: "border-orange-500 text-orange-400",
    red: "border-red-500 text-red-400",
  };
  return (
    <div className="flex flex-wrap items-end justify-between gap-4 mb-6">
      <div className={`border-l-4 pl-4 ${colors[accent]}`}>
        <h1 className="font-display text-3xl md:text-4xl font-extrabold uppercase tracking-wide text-white leading-none">
          {title}
        </h1>
        {subtitle && <p className="text-slate-400 text-sm mt-1.5">{subtitle}</p>}
      </div>
      {right}
    </div>
  );
}
